// Simple, safe markdown -> HTML renderer for AURA chat
// Supports: headings, bold, italic, inline code, code fences, links, lists, blockquotes, tables

function escape(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderMarkdown(src) {
  if (!src) return "";
  const lines = src.split("\n");
  let html = "";
  let inCode = false;
  let codeBuf = [];
  let codeLang = "";
  let inList = null;
  let inTable = false;
  let tableRows = [];

  const flushList = () => {
    if (inList) { html += `</${inList}>`; inList = null; }
  };
  const flushTable = () => {
    if (inTable && tableRows.length) {
      html += `<table><thead><tr>${tableRows[0].map(c => `<th>${inline(c)}</th>`).join("")}</tr></thead><tbody>`;
      for (let i = 2; i < tableRows.length; i++) {
        html += `<tr>${tableRows[i].map(c => `<td>${inline(c)}</td>`).join("")}</tr>`;
      }
      html += "</tbody></table>";
    }
    inTable = false; tableRows = [];
  };

  const inline = (t) => {
    let s = escape(t);
    s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
    s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    s = s.replace(/\*([^*\n]+)\*/g, "<em>$1</em>");
    s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    return s;
  };

  for (const raw of lines) {
    const line = raw;
    if (line.startsWith("```")) {
      if (!inCode) { inCode = true; codeLang = line.slice(3).trim(); codeBuf = []; flushList(); flushTable(); }
      else { inCode = false; html += `<pre><code>${escape(codeBuf.join("\n"))}</code></pre>`; codeBuf = []; }
      continue;
    }
    if (inCode) { codeBuf.push(line); continue; }

    // Tables
    if (line.includes("|") && line.trim().startsWith("|")) {
      flushList();
      inTable = true;
      const cells = line.split("|").slice(1, -1).map(c => c.trim());
      tableRows.push(cells);
      continue;
    } else if (inTable) { flushTable(); }

    const m = line.match(/^(#{1,3})\s+(.*)/);
    if (m) { flushList(); html += `<h${m[1].length}>${inline(m[2])}</h${m[1].length}>`; continue; }

    if (/^\s*[-*]\s+/.test(line)) {
      if (inList !== "ul") { flushList(); inList = "ul"; html += "<ul>"; }
      html += `<li>${inline(line.replace(/^\s*[-*]\s+/, ""))}</li>`;
      continue;
    }
    if (/^\s*\d+\.\s+/.test(line)) {
      if (inList !== "ol") { flushList(); inList = "ol"; html += "<ol>"; }
      html += `<li>${inline(line.replace(/^\s*\d+\.\s+/, ""))}</li>`;
      continue;
    }
    if (line.startsWith("> ")) { flushList(); html += `<blockquote>${inline(line.slice(2))}</blockquote>`; continue; }
    if (!line.trim()) { flushList(); html += ""; continue; }
    flushList();
    html += `<p>${inline(line)}</p>`;
  }
  flushList(); flushTable();
  if (inCode) html += `<pre><code>${escape(codeBuf.join("\n"))}</code></pre>`;
  return html;
}
